module.exports = __webpack_public_path__ + "static/assets/c924eafc54e53cd3202a871970882082.gif";